
import React, { Fragment, useState } from 'react'
import Slider from 'react-slick'

import classes from './VehiclePicSlider.scss'

const VehiclePicSliderRedux = ({ vehiclePics, changePrimaryDisplayImage }) =>
{
	const [sliderSettings, setSliderSettings] = useState({
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 4,
	})
	
	return (
		<Fragment>
			<Slider {...sliderSettings}>
				{
					vehiclePics.map((vehiclePic, index) => (
						<div key={index}>
							<div className={ classes.sliderItem }>
								<img src={ vehiclePic } alt="..." width="127" height="95" onClick={ () => changePrimaryDisplayImage(vehiclePic) } style={{ cursor: 'pointer' }} />
							</div>
						</div>
					))
				}
			</Slider>
		</Fragment>
	)
}

export default VehiclePicSliderRedux
